import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	title?: React.ReactElement;
}

const StyledTitle = styled.div`
	color: #000000;
	font-weight: 700;
	font-size: 32px;
	line-height: 41px;
`;

export const Title: FC<Props> = props => {
	const { title = 'Join Now to Lose Weight and Keep it Off' } = props;
	return <StyledTitle>{title}</StyledTitle>;
};
